import { DatePicker, Flex, Label } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";
import { getDateParameterLabel } from "./constants";
import { formatIsoDate, parseIsoDate } from "./isoDate";
import type { DateParameterFieldsState } from "./derive";

/** The app-wide display format first (react-datepicker renders with entry one),
 * then the wire format so a pasted ISO date still parses. The array matters
 * beyond the extra format: react-datepicker only falls back to `new Date(str)`
 * — which reads a date-only string as UTC and lands a day early west of it —
 * when `dateFormat` is a lone string. */
const INPUT_DATE_FORMATS = ["MM/dd/yyyy", "yyyy-MM-dd"];

export type PreviewDateParameterFieldsProps = {
  dateParameters: DateParameterFieldsState;
};

/** One date input per `DateParameter` the query requires, rendered inside the
 * preview settings panel. Renders nothing when the query needs no dates. */
export const PreviewDateParameterFields = ({
  dateParameters: { requiredParameters, values, setValue },
}: PreviewDateParameterFieldsProps) => {
  if (requiredParameters.length === 0) {
    return null;
  }

  return (
    <>
      {requiredParameters.map((parameter) => {
        const inputId = `preview-date-parameter-${parameter}`;
        return (
          <Flex key={parameter} flexDirection="column" gap={SPACING.X_SMALL}>
            <Label htmlFor={inputId}>{getDateParameterLabel(parameter)}</Label>
            <DatePicker
              id={inputId}
              isFull
              hasIcon
              dateFormat={INPUT_DATE_FORMATS}
              placeholderText="Select date"
              selected={parseIsoDate(values[parameter] ?? null)}
              onChange={(date) => setValue(parameter, formatIsoDate(date))}
            />
          </Flex>
        );
      })}
    </>
  );
};
